import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/business-energy-plan", label: "Business Energy Plan" },
  { to: "/industries", label: "Industries" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-lg border-b border-black/5"
      data-testid="site-header"
    >
      <div className="container-x mx-auto max-w-7xl flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-forest text-white">
            <Leaf size={18} strokeWidth={2.2} />
          </span>
          <span className="font-heading text-[17px] md:text-lg font-semibold tracking-tight text-forest">
            Be Green Group
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace(/\//g, "").replace(/-/g, "_") || "home"}`}
              className={`text-[14.5px] font-medium transition-colors ${
                pathname === n.to
                  ? "text-forest"
                  : "text-neutral-600 hover:text-forest"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <Link to="/admin/login" className="text-sm text-neutral-500 hover:text-forest transition-colors px-3">
            Admin
          </Link>
          <Link to="/apply" data-testid="header-apply-cta">
            <Button className="bg-bright hover:bg-bright/90 text-[hsl(150_40%_8%)] rounded-full h-10 px-5 font-semibold">
              Check Eligibility
            </Button>
          </Link>
        </div>

        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-black/5 bg-white" data-testid="mobile-nav">
          <div className="container-x mx-auto max-w-7xl py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="py-3 text-base text-neutral-700"
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/apply"
              onClick={() => setOpen(false)}
              className="mt-3"
              data-testid="mobile-apply-cta"
            >
              <Button className="w-full bg-bright hover:bg-bright/90 text-[hsl(150_40%_8%)] rounded-full h-11 font-semibold">
                Check My Business Eligibility
              </Button>
            </Link>
            <Link
              to="/admin/login"
              onClick={() => setOpen(false)}
              className="text-center py-3 text-sm text-neutral-500"
            >
              Admin sign in
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
